<template>
  <div>
    <el-date-picker class="datePicker" clearable prefix-icon="" :editable="false" v-model="localValue"
      value-format="yyyy-MM-dd" type="date" :placeholder="`请选择${txt}日期`" @change="changeDate">
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "datePicker",
  props: {
    txt: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Date],
      default: ''
    }
  },
  data() {
    return {
      localValue: this.value,

    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    // 监听 localValue 的变化，并通知父组件
    localValue(newVal) {
      this.$emit('changeDate', newVal);
    }
  },
  methods: {
    changeDate(val) {
      if (val == null) {
        this.$emit("changeDate", '');
      } else {
        this.$emit("changeDate", val);
      }

    }
  },

};
</script>

<style scoped>
.datePicker {
  width: 100%;
  box-sizing: border-box;
}
</style>